/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable operator-assignment */
import { cloneDeep } from 'lodash'
import { DeviceType } from '@adalo/constants'
import { EditorObject } from 'utils/responsiveTypes'
import traverseChildren from './traverseChildren'

type EditorInputObject = Partial<EditorObject> & {
  contentChildren?: EditorObject['children']
}

const getFakeId = () =>
  `fake-id-${String(Math.random()).split('.')[1] as string}`

/**
 *
 * Takes an EditorObject and returns an object that can be used as an input for the `createObject` action
 */
const getInputObjectFromEditorObject = (
  obj: EditorObject
): EditorInputObject => {
  const initialX = obj.x ?? 0
  const initialY = obj.y ?? 0

  const initialCoordinatesByDevice: { [key: string]: any } = {}

  const devices = [DeviceType.DESKTOP, DeviceType.TABLET, DeviceType.MOBILE]
  for (const device of devices) {
    const initialDeviceX = obj[device]?.x
    const initialDeviceY = obj[device]?.y
    if (initialDeviceX !== undefined && initialDeviceY !== undefined) {
      initialCoordinatesByDevice[device] = {
        x: initialDeviceX,
        y: initialDeviceY,
      }
    }
  }

  let inputObj: EditorInputObject = cloneDeep(obj)

  // TODO(enzo): positions may not be normalized, but the performCreate that takes this object will transform it correctly anyways
  const SKIP_POSITION_UPDATE = true

  const shouldUpdatePositions =
    (initialX !== 0 || initialY !== 0) && !SKIP_POSITION_UPDATE

  const shouldRemoveIds = true

  const idMap: Record<string, string> = {}

  traverseChildren(inputObj, (innerObj: any) => {
    if (shouldRemoveIds && innerObj.id) {
      const fakeId = getFakeId()
      idMap[innerObj.id] = fakeId
      innerObj.id = fakeId
    }

    // Translate children
    if (shouldUpdatePositions) {
      if (innerObj?.x !== undefined && innerObj?.y !== undefined) {
        innerObj.x = innerObj.x - initialX
        innerObj.y = innerObj.y - initialY
      }
    }

    if (!SKIP_POSITION_UPDATE) {
      for (const device of devices) {
        if (initialCoordinatesByDevice[device]) {
          if (
            innerObj[device]?.x !== undefined &&
            innerObj[device]?.y !== undefined
          ) {
            innerObj[device].x =
              innerObj[device].x - initialCoordinatesByDevice[device].x
            innerObj[device].y =
              innerObj[device].y - initialCoordinatesByDevice[device].y
          }
        }
      }
    }
  })

  if (Object.entries(idMap).length > 0) {
    let inputObjString = JSON.stringify(inputObj)

    for (const [find, replace] of Object.entries(idMap)) {
      inputObjString = inputObjString.replace(new RegExp(find, 'g'), replace)
    }

    inputObj = JSON.parse(inputObjString) as EditorInputObject
  }

  return inputObj
}

export default getInputObjectFromEditorObject
